import type InvoiceSerializer from "issara-sdk/types/InvoiceSerializer_apps_BIL";

export const ORDER_SUMMARY_LIMIT = 20;

export type PaymentChannel = "SLIP" | "2C2P" | "COUNTER";

export type OrderSummaryFilter = {
  payment_channel?: PaymentChannel;
  status?: "PAID" | "BILLED";
  search?: string;
  from_date?: string;
  to_date?: string;
};

export const DEFAULT_ORDER_SUMMARY_FILTER: OrderSummaryFilter = { status: "PAID" };

export type PackageSummaryItem = {
  id: number;
  product_name?: string;
  product_name_en?: string;
  product_code?: string;
  quantity: string | number;
  ordered_quantity: string | number;
};

export type PackageSummaryOrder = {
  id: number;
  product_name?: string;
  product_name_en?: string;
  product_code?: string;
  quantity: string | number;
  price_full?: string | number;
  items: PackageSummaryItem[];
};

export type PackageSummaryInvoice = InvoiceSerializer & {
  id: number;
  payment_channel: PaymentChannel | "MIXED" | null;
  payment_channels: PaymentChannel[];
  paid_at: string | null;
  slip_status: string | null;
  patient_paid_at: string | null;
  payment_confirmation: string | null;
  orders: PackageSummaryOrder[];
};

export type OrderSummaryList = {
  divisionId: number;
  filter: OrderSummaryFilter;
  items: PackageSummaryInvoice[];
  total: number;
  activePage: number;
  loading: boolean;
  error: "LOAD_FAILED" | null;
};
